import { useCallback, useMemo } from 'react';

export const transformSortingOption = (sorting) => {
  if (Array.isArray(sorting) && sorting.length > 1) {
    return sorting;
  }
  const sortingOption = sorting && Array.isArray(sorting) ? sorting[0] : undefined;
  let sort = sortingOption;
  // TODO: Fix hight -> high typo when Inline Filter are used across all containers
  // TODO: IMPORTANT -> Think about how to improve the sorting parameters since the APIs do not always have the same way to sort
  if (typeof sortingOption === 'object') {
    if (sortingOption.usdTotalPrice) {
      if (sortingOption.usdTotalPrice === 'ASC') {
        sort = 'price_low_to_hight';
      }
      if (sortingOption.usdTotalPrice === 'DESC') {
        sort = 'price_hight_to_low';
      }
    } else if (sortingOption['priceSpecification.usdTotalPrice']) {
      if (sortingOption['priceSpecification.usdTotalPrice'] === 'ASC') {
        sort = 'price_specification_low_to_high';
      }
      if (sortingOption['priceSpecification.usdTotalPrice'] === 'DESC') {
        sort = 'price_specification_high_to_low';
      }
    } else if (sortingOption.departureDate && sortingOption.departureDate === 'ASC') {
      sort = 'departure_date';
    } else if (sortingOption.popularity && sortingOption.popularity === 'DESC') {
      sort = 'most_popular';
    } else if (sortingOption['hotel.rating.value']) {
      if (sortingOption['hotel.rating.value'] === 'DESC') {
        sort = 'star_rating_high_to_low';
      }
      if (sortingOption['hotel.rating.value'] === 'ASC') {
        sort = 'star_rating_low_to_high';
      }
    } else if (sortingOption['journey.flightDeltaDays']) {
      if (sortingOption['journey.flightDeltaDays'] === 'DESC') {
        sort = 'duration_high_to_low';
      }
      if (sortingOption['journey.flightDeltaDays'] === 'ASC') {
        sort = 'duration_low_to_high';
      }
    }
  }
  return sort;
};

export function useSorting({ dispatch, value, initValue }) {
  const onChange = useCallback(
    (event) => {
      const { options, selectedIndex, value } = event.target;
      dispatch({
        type: 'SORTING_CHANGE',
        payload: { value, label: options[selectedIndex].text }
      });
    },
    [dispatch]
  );

  return useMemo(
    () => ({
      selectedOption: typeof value === 'string' ? value : 'no_sorting',
      value,
      onChange,
      isChanged: initValue !== value
    }),
    [initValue, onChange, value]
  );
}
